<template>
<div class="header_wrap">
    <header class=" ">
 <div class="container navbar sticky">
    <template v-if="get_header.images">
       <router-link to="/" class="logo" v-for="image in get_header.images" :key="image.id">
        <span class="sp_b">LADE</span>
     <img  :src="image.url" alt="LADE">
     </router-link>
    </template>
  <div class="menu-btn">
    <div class="menu-btn__lines"></div>
  </div>
  <ul class="menu-items">
     <template v-for="link in get_header.pages">
       <template v-if="link.type=='STATIC'">
         <li :key="link.id"><router-link class="menu-item first-item" :to="`/${link.link}`">{{link.name}}</router-link></li>
       </template>
        <template v-else-if="link.type=='MENU' && link.menu.categories"> 
           <!-- mega -->
      <li :key="link.id">
      <div  class="menu-item first-item expand-btn">{{link.name}}</div>
      <div class="mega-menu sample">
        <div class="content">
       <div class="title_mega">
         <h1>VÅRE TJENESTER</h1>
       </div>
       <div class="flex_service">
      
        <router-link  :to="`/service/${megaMenu.id}`" @click.native="hide_mega()" class="single_mega_box" v-for="megaMenu in link.menu.categories" :key="megaMenu.id">
            <div class="box_mega">
                <div class="img_mega">
                    <img :src="megaMenu.image" alt="">
                </div>
                <div class="text_mega">
                    <span>{{megaMenu.title}}</span>
                </div>
            </div>
        </router-link>
       </div>
        </div>
      </div>
    </li>
    <!-- mega -->
        </template>
        <template v-else-if="link.type=='MENU' && link.menu.services">
    <!-- mega -->
      <li :key="link.id">
      <a href="#" class="menu-item first-item expand-btn">{{link.name}}</a>
      <div class="mega-menu sample">
        <div class="content">
       <div class="title_mega">
         <h1>VÅRE TJENESTER</h1>
       </div>
       <div class="flex_service">
      
        <router-link  :to="`/service/${1}`" @click.native="hide_mega()" class="single_mega_box" v-for="megaMenu in link.menu.categories" :key="megaMenu.id">
            <div class="box_mega">
                <div class="img_mega">
                    <img :src="megaMenu.image.url" alt="">
                </div>
                <div class="text_mega">
                    <span>{{megaMenu.title}}</span>
                </div>
            </div>
        </router-link>
       </div>
        </div>
      </div>
    </li>
    <!-- mega -->
        </template>
     </template>
    <!-- <li><router-link to="/" class="menu-item first-item">Home</router-link></li>
     <li><router-link to="/works" class="menu-item first-item">Prosjekter</router-link></li> -->
     <!-- <li><router-link to="/about-us" class="menu-item first-item">Om Oss</router-link></li>
      <li><router-link to="/testimonial" class="menu-item first-item">Testimonials</router-link></li>
       <li><router-link to="/contact" class="menu-item first-item">Kontakt Oss</router-link></li> -->
       <template v-if="authenticated">
        <li><router-link to="/profile/user" class="menu-item first-item user_online">
        <vs-avatar badge badge-color="success">
          <i class='bx bx-user'></i>
      </vs-avatar>
       </router-link>
       </li>
       </template>
       <template v-else>
        <li><router-link to="/login" class="menu-item first-item user_online">
        <vs-avatar badge badge-color="success">
          <i class='bx bx-user'></i>
      </vs-avatar>
       </router-link>
       </li>
       </template>
      <li><router-link  to="/booking" class="menu-item first-item head_sq squ">BESTILL TIME</router-link></li>
       
  </ul>
 </div>
    </header>
<div class="overlay"></div>
</div>
</template>
<script>
import {mapGetters} from 'vuex';
import $ from 'jquery';
export default {
  name: "headerApp",
  data() {
    return {
      my_serviec: [
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/polering.jpg",
          title: "POLERING",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/INNVENDIG-VASK-1.jpg",
          title: "INNVENDIG VASK",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/UTVENDIG-VASK-1.jpg",
          title: "UTVENDIG VASK",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/Keramisk-lakkbeskyttelse-1.jpg",
          title: "KERAMISK LAKKBESKYTTELSE",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/OZON-BEHANDLING.jpg",
          title: "OZON BEHANDLING",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/GULLPAKKE.jpg",
          title: "GULLPAKKE",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/Laer-skinn.jpg",
          title: "LÆR & SKINN",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/DEKORFJERNING-1.jpg",
          title: "DEKORFJERNING",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/BILGLASS-1.jpg",
          title: "BILGLASS",
        },
         {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/Age-Stop.jpg",
          title: "AGE STOP",
        },
         {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/Xpel.jpg",
          title: "XPEL",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/SLIPING-AV-FRONTLYKTER.jpg",
          title: "SLIPING AV FRONTLYKTER",
        },
        {
          img: "https://www.bpst.no/wp-content/uploads/2022/12/Lakkering.jpg",
          title: "LAKKERING",
        },
      ],
    };
  },
     computed:{
    ...mapGetters({
        authenticated:'auth/authenticated',
        user:'auth/user',
        get_header:'get_header',
    })
    } ,
  methods:{
    func_responseive(){
        const overlay = document.querySelector(".overlay");
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menu-btn");
const menuItems = document.querySelector(".menu-items");
const expandBtn = document.querySelectorAll(".expand-btn");

function toggle() {
  // disable overflow body
  body.classList.toggle("overflow");
  // dark background
  overlay.classList.toggle("overlay--active");
  // add open class
  menuBtn.classList.toggle("open");
  menuItems.classList.toggle("open");
}

menuBtn.addEventListener("click", (e) => {
  e.stopPropagation();
  toggle();
});

window.onkeydown = function (event) {
  const key = event.key; // const {key} = event; in ES6+
  const active = menuItems.classList.contains("open");
  if (key === "Escape" && active) {
    toggle();
  }
};

document.addEventListener("click", (e) => {
  let target = e.target,
    its_menu = target === menuItems || menuItems.contains(target),
    its_hamburger = target === menuBtn,
    menu_is_active = menuItems.classList.contains("open");
  if (!its_menu && !its_hamburger && menu_is_active) {
    toggle();
  }
});

document.querySelectorAll('.menu-items a').forEach((elm)=>{
  elm.addEventListener('click',()=>{
    toggle();
  })
})
// mobile menu expand
expandBtn.forEach((btn) => {
  btn.addEventListener("click", () => {
    btn.classList.toggle("open");
  });
});

    },
       hide_mega(){
         $('.mega-menu').addClass('hide_mega')
            setTimeout(()=>{
                 $('.mega-menu').removeClass('hide_mega')
    },500)
        },
  },
  mounted(){
    this.func_responseive();
  }
};
</script>
<style lang="scss" scoped>

/* navbar */
.header_wrap{
    padding: 25px 0px;
}
.navbar {
  background: transparent;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0px;
//   -webkit-box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);
//   box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);
}
.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 999;
}
.title_mega{
    text-align: center;
    h1{
        color: black;
            font-size: 45px;
    font-weight: 600;
        font-family: 'Oswald',sans-serif;
    text-transform: uppercase;
    margin: 0;
    line-height: unset;
    }
}
.flex_service{
    margin-top: 14px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .single_mega_box{
        flex: 0 0 calc(100% / 5);
        padding: 4px;
        margin-bottom: 4px;
        cursor: pointer;
        .box_mega{
            text-align: center;
            .img_mega{
                margin-bottom: 4px;
                img{
                    transition: 0.15s linear;
                    width: 90%;
                    margin: 0 auto;
                    &:hover{
                        transform: scale(1.07);
                    }
                }
            }
            .text_mega{
                span{
                        font-size: 15px;
    line-height: 1.2em;
    color: black;
        font-family: 'Oswald',sans-serif;
    text-transform: uppercase;
        font-weight: 700;
                }
            }
        }
    }
}

.navbar .logo {
  text-decoration: none;
  color: #122f48;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 20px;
  width: 200px;
   .sp_b{
    position: absolute;
    font-size: 14px;
    transform: rotate(332deg);
    left: 25px;
    top: 12px;
    font-weight: 500;
    color: #fff;
     font-family: "Oswald", sans-serif;
  }
  img{
    width: 100%;
    height: 80px;
    object-fit: contain;
  }
}


/* nav menu button */

.menu-btn {
  position: relative;
  display: none;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  z-index: 2;
}

.navbar .menu-btn__lines::before,
.navbar .menu-btn__lines::after {
  content: "";
  position: absolute;
}

.navbar .menu-btn__lines,
.navbar .menu-btn__lines::before,
.navbar .menu-btn__lines::after {
  width: 1.5rem;
  height: 0.1rem;
  background: var(--active_color);
  transition: all 0.4s ease-in-out;
}

.navbar .menu-btn__lines::before {
  transform: translateY(-0.5rem);
}

.navbar .menu-btn__lines::after {
  transform: translateY(0.5rem);
}

.navbar .menu-items {
  display: flex;
  align-items: center;
    justify-content: flex-end;
    flex: 0 0 calc(100% - 200px);
}

.navbar ul li {
  list-style: none;
  transition: 0.3s ease;
}

.navbar ul li .arrow {
  transition: all 0.3s ease-out;
}

.navbar ul li a {
  text-decoration: none;
  color: #112f48;
}

/* dropdown menu */

.navbar .dropdown {
  position: relative;
}
.expand-btn:after {
 content: "\f078";
    opacity: 0.4;
    font-family: "Font Awesome 5 Pro";
    margin-left: 7px;
    color: white;
    font-weight: 600;
    font-size: .6rem;
    transition: 0.2s opacity linear;
}

.navbar .dropdown-menu,
.menu-right {
  position: absolute;
  background: #e9ecef;
  width: 190px;
  line-height: 30px;
  border-radius: 0 0 5px 5px;
  top: 65px;
  border-top: 1px solid white;
  left: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease;
  -webkit-box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);
  box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);
}

.navbar .menu-right {
  top: 0;
  left: 100%;
}
.navbar .dropdown-menu,
.menu-left {
  left: unset;
  right: 0;
}
.navbar .menu-left {
  left: -100%;
}

.navbar .menu-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 1.5rem;
  font-size: 14px;
}
.navbar .menu-item:hover {
  color:white;
}
 .expand-btn:hover.expand-btn:after{
    color: #ffffff;
    opacity: 1;

    }


.menu-item.first-item {
  padding: 1.5rem 1rem;
    height: 100px !important;
    display: flex;
    align-items: center;
    color: #ffffffbf;
    transition: all .2s linear;
    font-size: 16px;
    font-weight: 400;
}

.navbar .dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
}

.navbar .dropdown-right:hover .menu-right {
  left: 100%;
  opacity: 1;
  visibility: visible;
}

.navbar .dropdown-right:hover .menu-left {
  left: -100%;
}

/* mega menu  */

.navbar .mega-menu {
  position: absolute;
  left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    // width: calc(100vw - 160px);
//   width: 100vw;
  top: 90px;
  border-top: 1px solid #ffffff;
  opacity: 0;
  visibility: hidden;
   transition: all 0.1s ease-out 0s, visibility 0.1s linear 0s;
//transition: 0.1s linear;
}

.mega-menu .content {
  background: #e9ecef;
  padding: 1rem;
//   display: grid;
//   grid-template-columns: repeat(4, 1fr);
//   gap: 1rem;
  width: 100%;
//   justify-content: space-between;
  -webkit-box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);
  box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);
}

.blog .content {
  grid-template-columns: repeat(4, 1fr);
}

.content .col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 3rem;
}

.content .col .img-wrapper {
  display: block;
  position: relative;
  width: 100%;
  height: 20vw;
  overflow: hidden;
}

.content .col .img {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.content .col img {
  width: 100%;
  transition: transform 0.3s ease-in-out;
}

.content .col .img-wrapper:hover img {
  transform: scale(1.1);
}

.content .col .menu-title {
  color: var(--active_color);
  font-size: 1.2rem;
  line-height: 3rem;
  font-weight: bold;
}

.content .col p {
  line-height: 1.2rem;
  margin-top: 5px;
  color: #112f48;
}

.content .col .mega-links {
  border-left: 1px solid #3c3c3c;
}

.content .col .read-more {
  font-size: 16px;
  display: flex;
  padding-top: 1rem;
  color: #03a9f4;
  transition: color 0.3s ease;
  justify-content: flex-end;
  padding-right: 10px;
}

.col .mega-links li,
.col .mega-links li a {
  padding: 0 1rem;
}

.menu-items li:hover .mega-menu {
  opacity: 1;
  visibility: visible; 
}
.hide_mega{
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none;
}

.content .col .read-more:hover {
  color: var(--active_color);
}

/* container */
// .container {
//   margin: 100px auto auto;
//   padding: 0 15px;
//   max-width: 1200px;
//   text-align: center;
// }
.container p {
  color: #ffffff;
}

h1 {
  font-weight: 700;
  line-height: 10vw;
  color: #ffffff;
  text-transform: uppercase;
}

/* animation menu hamburger */
.menu-btn.open .menu-btn__lines {
  transform: translateX(1rem);
  background: transparent;
}

.menu-btn.open .menu-btn__lines::before {
  transform: rotate(45deg) translate(-0.5rem, 0.5rem);
  background: var(--active_color);
}

.menu-btn.open .menu-btn__lines::after {
  transform: rotate(-45deg) translate(-0.5rem, -0.5rem);
  background: var(--active_color);
}

/* Responsive style */
@media(max-width:1199px){
  .menu-item.first-item{
    padding: 1.5rem 0.5rem;
  }
}
@media screen and (max-width: 1024px) {

  .header_wrap{
    background-color: black;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    padding: 10px 0px;
  }
  .menu-item.first-item.head_sq {
    padding: 0.4rem 1rem !important;
    height: 38px !important;
    margin: 0;
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--active_color);
    display: inline-flex;
    margin-top: 24px;
    width: auto;
}
.vs-avatar {
    background-color: #2a2a2a;
    color: var(--active_color);
    margin-right: 20px;
}
.menu-item.first-item{
    padding: 1.5rem 1rem;
    height: 60px !important;
}
  .navbar {
    padding: 10px 20px;
  }

  .overflow {
    overflow: hidden;
  }

  .overlay {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 500;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  }

  .overlay--active {
    opacity: 1;
    visibility: visible;
  }

  .menu-btn {
    display: flex;
  }

  .navbar .menu-items {
    position: fixed;
    height: 100%;
    max-height: initial;
    overflow-y: auto;
    width: 80%;
    top: 100px;
    margin: 0;
    left: -80%;
    background: #000;
    display: block;
    transform: translateX(-100vh);
    transition: 0.5s ease-in-out;
    padding-bottom: 180px;
  }
  .flex_service .single_mega_box{
    flex: 0 0 50%;
    padding: 4px;
    margin-bottom: 4px;
    cursor: pointer;
}
.mega-menu .content {
    background: #000000;
}
.title_mega h1[data-v-7c98f0f8] {
    color: var(--active_color);
    font-size: 30px;
}
.flex_service .single_mega_box .box_mega .text_mega span {
    font-size: 15px;
    padding-top: 12px;
    margin-bottom: 10px;
    display: block;
    color: white;
}
  .menu-items.open {
    transform: translateY(0);
    left: 0;
  }

  .menu-items li:first-child {
    margin-top: 20px;
  }

  .menu-items li a {
    padding: 10px 1rem;
    display: block;
    font-size: 18px;
  }

  .menu-items .dropdown-right .right-arrow {
    transform: rotate(90deg);
  }

  .menu-item.first-item {
    padding: 1rem 1rem;
  }

  /* DROPDOWN, MEGA MENUS */
  .menu-items .dropdown-menu,
  .menu-items .menu-right,
  .menu-items .mega-menu {
    position: static;
    opacity: 1;
    top: 4rem;
    visibility: visible;
    margin-left: -18px;
    width: auto;
    max-height: 0;
    transform: scaleX(0);
    transform-origin: top;
    overflow: hidden;
    transition: all 0.5s ease;
  }

  .menu-items .dropdown-menu,
  .menu-items .menu-right {
    padding-left: 1rem;
    width: 102%;
    margin-left: -10px;
  }

  .menu-items .mega-menu .col {
    padding-left: 1rem;
  }

  .expand-btn.open + .sample {
    max-height: 100%;
    transform: scaleZ(1);
  }

  .expand-btn.open + .blog.sample {
    max-height: 100%;
    transform: scaleZ(1);
    max-width: fit-content;
  }

  .navbar .sample {
    border-top: none;
  }

  .sample li {
    margin: 0;
  }

  .sample li:last-child {
    border-bottom: none;
  }

  .sample li a {
    font-size: 1rem;
  }

  .mega-menu .content {
    grid-template-columns: auto;
    padding: 1rem 1rem 0 1rem;
  }

  .mega-menu .content .col {
    width: 100%;
    padding-top: 1rem;
    margin-bottom: 0.5rem;
  }

  .col .mega-links li,
  .col .mega-links li a {
    padding: 0 0.5rem;
  }

  .content .col .mega-links {
    border-left: 0;
    padding-left: 0.5rem;
  }
  .col .mega-links li {
    margin: 0;
  }
}

@media(max-width:992px){
  .flex_service .single_mega_box{
    flex: 0 0 100%;
    padding: 4px;
    margin-bottom: 4px;
    cursor: pointer;
}
.title_mega h1 {
    font-size: 20px !important;
}
}

</style>
